import { ModelPickerSlot } from '#pplx/frontend/apps/ask/composer-sdk-plugins/model-selector/modelPickerPluginComponents.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
/**
 * Hosts the Ask model picker, surface-owned effort control, or pinned Computer
 * model chip in the composer's right attribution. Model state lives in the
 * surrounding thread-config contexts, so the slot reads it through the same
 * controller the legacy right attribution uses; effort policy stays with the surface.
 */
export const createModelPickerPlugin = createPluginFactory({
    name: 'xplat-model-picker',
    capabilities: [
        { kind: 'slot', components: [{ slot: 'rightAttribution', component: ModelPickerSlot }] },
    ],
});
//# sourceMappingURL=modelPickerPlugin.js.map